import { Eth } from 'web3-eth'

import { eip165ABI } from '@/shared/abis/eip165ABI'
import { logError } from '@/shared/logger'
import { UpAddress } from '@/shared/models/Profile'

/**
 * Checks if a smart contract supports a given interface.
 * https://eips.ethereum.org/EIPS/eip-165
 *
 * @param Eth web3Eth - an instance of web3 eth
 * @param string address - an address for the smart contract
 * @param string interfaceId - an interfaceId to check
 * @returns true/false whether the transaction supports the interface or not
 */
export const checkInterface = async (
  web3Eth: Eth,
  address: UpAddress,
  interfaceId: string
): Promise<boolean> => {
  try {
    const eip165Contract = new web3Eth.Contract(eip165ABI as any, address)
    return await eip165Contract.methods.supportsInterface(interfaceId).call()
  } catch (error: unknown) {
    logError(`Error while checking interface:`, error)
    return false
  }
}
